import { cn } from "@/utils/cn";
import { useIonRouter } from "@ionic/react";

interface UnderlineLinkProps {
  path?: string;
  text: string;
  className?: string;
  replace?: boolean;
  onClick?: () => void;
}

export default function UnderlineLink({
  path,
  text,
  className,
  replace = false,
  onClick,
}: UnderlineLinkProps) {
  const navigation = useIonRouter();

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (!path) {
      return;
    }

    navigation.push(path, "forward", replace ? "replace" : "push");
  };

  return (
    <span
      onClick={handleClick}
      className={cn("cursor-pointer underline hover:opacity-80", className)}
    >
      {text}
    </span>
  );
}
